import React from "react";
import { useNavigate } from "react-router-dom";
import { slugifyCar } from "../../utils/slugify";
import { FaUser, FaSuitcase, FaCheck } from "react-icons/fa";
import { GiCarDoor } from "react-icons/gi";
import { PiGasCanFill } from "react-icons/pi";

// Import all images
import OpelCorsa from "../../assets/images/opelcorsa.jpg";
import SpaceStar from "../../assets/images/MITS-SPACE.png";
import Peugeot208 from "../../assets/images/p-208.jpg";
import Peugeot108 from "../../assets/images/108-p.webp";
import CitroenC1 from "../../assets/images/C1.jpeg";
import Micra from "../../assets/images/PHOTO-2022-01-23-14-12-06.jpg";
import Panda from "../../assets/images/PHOTO-2022-01-23-14-12-05-1.jpg";
import Stonic from "../../assets/images/KIA-STONIC-Manual-1.png";
import i20 from "../../assets/images/HYUNDAI-i20-Manual-1.png";
import quashqai from "../../assets/images/quashqai.jpg";
import duster from "../../assets/images/duster.jpeg";
import crossland from "../../assets/images/opel-crossland.webp";
import clio from "../../assets/images/RENAULT-CLIO-Manual-1.png";
import rio from "../../assets/images/KIA-RIO-Auto-1.png";
import Wrangler5D from "../../assets/images/jeep-wr-5d.png";
import WranglerCabrio from "../../assets/images/Jeep-wrangler-cabrio.png";
import Discovery from "../../assets/images/land-rover.webp";
import Wrangler from "../../assets/images/JEEP-WRANGLER-Auto-1.png";
import WranglerSahara from "../../assets/images/JEEP-WRANGLER-1.png.webp";
import Berlingo from "../../assets/images/CITROEN-BERLINGO-Auto.png.webp";
import Doblo from "../../assets/images/FIAT-DOBLO-Manual-1.png.webp";
import TRoc from "../../assets/images/vw-t-roc.png";
import C1Cabrio from "../../assets/images/PHOTO-2022-01-23-14-12-11.jpg.webp";
import MiniCooper from "../../assets/images/MINI-COOPER-Cabrio-Auto-1.png.webp";
import Fiat500 from "../../assets/images/FIAT-500-Auto-Cabrio-1.png.webp";
import SmartForTwo from "../../assets/images/SMART-ForTwo-Cabrio-Manual-4.png.webp";
import SmartForTwoAuto from "../../assets/images/SMART-ForTwo-Cabrio-Auto-2.png.webp";
import Buggy800 from "../../assets/images/CF-MOTO-BUGGY-800cc-1.png.webp";
import Buggy550 from "../../assets/images/CF-MOTO-BUGGY-550cc-1.png.webp";
import ATV450 from "../../assets/images/5_14f72470629695dca3487f902b2c012f.png.webp";
import RangeSport from "../../assets/images/PHOTO-2022-01-22-12-09-42.jpg";
import C3Aircross from "../../assets/images/PHOTO-2022-01-25-15-13-22.jpg";
import C3 from "../../assets/images/PHOTO-2022-01-22-11-45-44-1.jpg";
import C4Cactus from "../../assets/images/PHOTO-2022-01-22-11-51-47.jpg";
import MiniCountryman from "../../assets/images/PHOTO-2022-01-25-15-13-22-1.jpg";
import Glb2022 from "../../assets/images/MERCEDES-BENZ-GLB-2022-Automatic-1.png";
import Gla2023 from "../../assets/images/253_9060274dbdc76eb56b4a456a70298fff.png";
import BmwX1 from "../../assets/images/BMW-X1-2023-Automatic.png";
import BmwX2 from "../../assets/images/BMW-X2-Automatic-1.png";
import Sportage from "../../assets/images/KIA-SPORTAGE-Auto-1.png";
import Cayenne from "../../assets/images/PORSCHE-CAYENNE-Auto-1.png";
import Bike125 from "../../assets/images/125bike.png";
import Picanto from "../../assets/images/picanto.jpg";

const imageMap = {
  "MITS-SPACE.png": SpaceStar,
  "p-208.jpg": Peugeot208,
  "108-p.webp": Peugeot108,
  "C1.jpeg": CitroenC1,
  "PHOTO-2022-01-23-14-12-06.jpg": Micra,
  "PHOTO-2022-01-23-14-12-05-1.jpg": Panda,
  "KIA-STONIC-Manual-1.png": Stonic,
  "HYUNDAI-i20-Manual-1.png": i20,
  "quashqai.jpg": quashqai,
  "duster.jpeg": duster,
  "opel-crossland.webp": crossland,
  "RENAULT-CLIO-Manual-1.png": clio,
  "KIA-RIO-Auto-1.png": rio,
  "jeep-wr-5d.png": Wrangler5D,
  "Jeep-wrangler-cabrio.png": WranglerCabrio,
  "land-rover.webp": Discovery,
  "JEEP-WRANGLER-Auto-1.png": Wrangler,
  "JEEP-WRANGLER-1.png.webp": WranglerSahara,
  "CITROEN-BERLINGO-Auto.png.webp": Berlingo,
  "FIAT-DOBLO-Manual-1.png.webp": Doblo,
  "vw-t-roc.png": TRoc,
  "PHOTO-2022-01-23-14-12-11.jpg.webp": C1Cabrio,
  "MINI-COOPER-Cabrio-Auto-1.png.webp": MiniCooper,
  "FIAT-500-Auto-Cabrio-1.png.webp": Fiat500,
  "SMART-ForTwo-Cabrio-Manual-4.png.webp": SmartForTwo,
  "SMART-ForTwo-Cabrio-Auto-2.png.webp": SmartForTwoAuto,
  "CF-MOTO-BUGGY-800cc-1.png.webp": Buggy800,
  "beach_buggy.png": Buggy550,
  "5_14f72470629695dca3487f902b2c012f.png.webp": ATV450,
  "PHOTO-2022-01-22-12-09-42.jpg": RangeSport,
  "PHOTO-2022-01-25-15-13-22.jpg": C3Aircross,
  "PHOTO-2022-01-22-11-45-44-1.jpg": C3,
  "PHOTO-2022-01-22-11-51-47.jpg": C4Cactus,
  "PHOTO-2022-01-25-15-13-22-1.jpg": MiniCountryman,
  "MERCEDES-BENZ-GLB-2022-Automatic-1.png": Glb2022,
  "253_9060274dbdc76eb56b4a456a70298fff.png": Gla2023,
  "BMW-X1-2023-Automatic.png": BmwX1,
  "BMW-X2-Automatic-1.png": BmwX2,
  "KIA-SPORTAGE-Auto-1.png": Sportage,
  "PORSCHE-CAYENNE-Auto-1.png": Cayenne,
  "land-rover.webp": Discovery,
  "Jeep-wrangler-cabrio.png": WranglerCabrio,
  "125bike.png": Bike125,
  "picanto.jpg": Picanto,
  "opelcorsa.jpg": OpelCorsa,
};

const CarCard = ({ car, selectedDates }) => {
  const navigate = useNavigate();
  const slug = slugifyCar(car);
  const handleCardClick = () => {
    navigate(`/car-details/${slug}`, {
      state: {
        car,
        dates: selectedDates,
      },
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleButtonClick = (e) => {
    e.stopPropagation();
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigate(`/car-details/${slug}`, {
      state: {
        car,
        dates: selectedDates,
      },
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const getImage = (imagePath) => {
    if (!imagePath) return null;

    if (typeof imagePath === "string") {
      // For database images with /images/ path
      if (imagePath.startsWith("/images/")) {
        const filename = imagePath.split("/").pop();
        return imageMap[filename] || imagePath;
      }
      // For existing static imports
      const filename = imagePath.split("/").pop();
      return imageMap[filename] || imagePath;
    }

    return imagePath;
  };

  // Use first image from images array or fallback to image property
  const carImage = getImage(
    Array.isArray(car.images) && car.images.length > 0
      ? car.images[0]
      : car.image
  );

  return (
    <div
      onClick={handleCardClick}
      className="mx-2 bg-white rounded-lg shadow-md overflow-hidden border border-gray-400 cursor-pointer transform transition-all duration-300 hover:shadow-xl hover:-translate-y-1 relative"
    >
      {/* Display insurance status for vehicles
      {car.vehicleInstances &&
        car.vehicleInstances.every(
          (v) => !v.insurance || new Date(v.insurance.endDate) < new Date()
        ) && (
          <div className="absolute top-2 right-2 bg-red-600 text-white text-xs px-2 py-1 rounded-full">
            Insurance Expired
          </div>
        )} */}

      <img
        src={carImage}
        alt={car.name}
        className="w-full h-60 object-cover my-4"
      />
      <div className="p-4">
        <h3 className="text-xl font-semibold mb-2 line-clamp-2 h-[3.5rem]">
          {car.name}
        </h3>

        <div className="flex items-center text-red-700 text-sm mb-4">
          <FaCheck className="mr-2 text-green-500 text-xs flex-shrink-0" />
          <span className="line-clamp-1">
            Free Cancellation up to 2 weeks prior pick-up time
          </span>
        </div>

        <div className="flex justify-between gap-4 mb-4">
          <div className="flex items-center">
            <FaUser className="mr-2 text-gray-500 text-xl" />
            <span>{car.seats || car.persons}</span>
          </div>
          <div className="flex items-center">
            <GiCarDoor className="mr-2 text-gray-500 text-2xl transform scale-x-[-1]" />
            <span>{car.doors}</span>
          </div>
          <div className="flex items-center">
            <FaSuitcase className="mr-2 text-gray-500 text-2xl" />
            <span>{car.suitcases}</span>
          </div>
          <div className="flex items-center">
            <PiGasCanFill className="mr-2 text-gray-500 text-2xl" />
            <span>
              {car.features
                ?.find((f) => f.includes("Fuel Tank"))
                ?.split("L")[0] || "46"}
              L
            </span>
          </div>
        </div>        <div className="flex justify-between items-center pt-4 border-t">
          <div className="text-blue-900 font-bold text-xl">
            €{car.dynamicPrice || car.basePrice || car.price}{" "}
            <span className="text-gray-400 text-sm font-thin">/ day</span>
          </div>
          <button
            onClick={handleButtonClick}
            className="bg-blue-900 text-white px-4 py-2 rounded hover:bg-red-600 transition relative z-10"
          >
            Rent Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default CarCard;
